/* off hours. theme layer: waitlist dialog + cart add-on button. No dependencies. */
(function () {
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const slug = (s) => String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

  /* Waitlist */
  const dlg = document.getElementById('OhWaitlist');
  if (dlg) {
    const box = dlg.querySelector('[data-oh-wl-items]');
    const tags = dlg.querySelector('[data-oh-wl-tags]');
    const form = dlg.querySelector('form');
    const syncTags = () => {
      const picked = [...box.querySelectorAll('input:checked')].map((i) => 'waitlist-' + slug(i.value));
      tags.value = ['waitlist'].concat(picked).join(',');
    };
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-oh-waitlist]');
      if (t) {
        e.preventDefault();
        const items = t.getAttribute('data-oh-waitlist').split(',').map((s) => s.trim()).filter(Boolean);
        box.innerHTML = items.map((it, i) => `<label><input type="checkbox" value="${esc(it)}"${i < 2 ? ' checked' : ''}> ${esc(it)}</label>`).join('');
        syncTags();
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        const email = dlg.querySelector('input[type="email"]');
        if (email) setTimeout(() => email.focus(), 50);
      }
      if (e.target.closest('[data-oh-wl-close]')) dlg.close();
    });
    box.addEventListener('change', syncTags);
    if (form) form.addEventListener('submit', syncTags);
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    /* Reopen after the post-back so the shopper sees the confirmation. */
    if (dlg.querySelector('.oh-form-ok') && typeof dlg.showModal === 'function') dlg.showModal();
  }

  /* Cart drawer / cart page add-on: add one item and refresh the drawer in place. */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-oh-addon]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    const drawer = document.querySelector('cart-drawer');
    try {
      const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.ohAddon), quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok) { btn.disabled = false; return; }
      if (document.getElementById('main-cart-items')) {
        window.location.reload();
      } else if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    } catch (err) {
      btn.disabled = false;
    }
  });
})();
